/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusIcon16Solid = forwardRef('PlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 2A1.5 1.5 0 0 1 9 3.5V7h3.5a1.5 1.5 0 0 1 0 3H9v3.5a1.5 1.5 0 0 1-3 0V10H2.5a1.5 1.5 0 1 1 0-3H6V3.5A1.5 1.5 0 0 1 7.5 2Z" })));
});
